// WHY: no real URI scheme contains a dot, so excluding it (vs. RFC 3986's technically-broader
// grammar) keeps a bare "host:port" like "www.acme.com:8443" from being misread as a scheme.
const PROTOCOL_PATTERN = /^([a-z][a-z0-9+-]*):/i;
const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);
// WHY: a real URI scheme's content is never pure digits, so this distinguishes a dotless scheme
// from a "host:port" shape like "erp-portal:9000".
const PORT_LIKE_SCHEME_PART_PATTERN = /^\d+(\/|\?|#|$)/;
// WHY: this value is rendered as a live href, so a disallowed protocol (javascript:, data:,
// etc.) must be rejected rather than passed through to a customer:view holder's session.
export function externalUrlHref(url) {
    const trimmed = url?.trim();
    if (!trimmed)
        return null;
    const match = PROTOCOL_PATTERN.exec(trimmed);
    if (!match || PORT_LIKE_SCHEME_PART_PATTERN.test(trimmed.slice(match[0].length))) {
        return `https://${trimmed}`;
    }
    return ALLOWED_PROTOCOLS.has(match[1].toLowerCase() + ':') ? trimmed : null;
}
//# sourceMappingURL=external-url-href.js.map